import { render } from "./auth-register.vue?vue&type=template&id=3778ccf1&scoped=true"
import script from "./auth-register.vue?vue&type=script&lang=js"
export * from "./auth-register.vue?vue&type=script&lang=js"

import "./auth-register.vue?vue&type=style&index=0&id=3778ccf1&lang=scss&scoped=true"

import exportComponent from "/data/.jenkins/workspace/WEB-samp-webapp-HK/common/temp/node_modules/.pnpm/vue-loader@16.8.3_webpack@4.46.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3778ccf1"]])

export default __exports__